import React, { createContext, useEffect, useRef, useState } from "react";

export const OrderContext = createContext({
  currentOrder: [],
  addToOrder: (val, type) => {},
  removeFromOrder: (val) => {},
  updateOrder: (val) => {},
});

export const OrderProvider = ({ children }) => {
  const [currentOrder, setCurrentOrder] = useState([]);
  const isFirstRender = useRef(true);
  useEffect(() => {
    const storedOrder = localStorage.getItem("currentOrder");
    if (storedOrder) {
      setCurrentOrder(JSON.parse(storedOrder));
    }
  }, []);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false; // toggle flag after first render/mounting
      return;
    }
    localStorage.setItem("currentOrder", JSON.stringify(currentOrder));
  }, [currentOrder]);

  const updateOrder = (newArray) => {
    setCurrentOrder(newArray);
  };
  const addToOrder = (product, type) => {
    const newArr = [...currentOrder];
    const targetedProduct = newArr.find((item) => {
      return (
        item.sku === product.sku &&
        item.hinge === product.hinge &&
        item.type === product.type &&
        item.drawer === product.drawer &&
        item.isCustom === product.isCustom &&
        item.description === product.description
      );
    });
    if (targetedProduct) {
      const index = newArr.indexOf(targetedProduct);
      const totalQty = newArr[index].qty + product.qty;
      if (type === "add") {
        newArr[index].qty = totalQty < 100 ? totalQty : 100;
      } else if (type === "edit") {
        newArr[index].qty = product.qty < 100 ? product.qty : 100;
      }
    } else {
      newArr.push(product);
    }
    updateOrder(newArr);
  };

  const removeFromOrder = (index) => {
    const array = [...currentOrder]; // make a separate copy of the array
    array.splice(index, 1);
    updateOrder(array);
  };
  const value = {
    currentOrder,
    addToOrder,
    removeFromOrder,
    updateOrder: updateOrder,
  };

  return (
    <OrderContext.Provider value={value}>{children}</OrderContext.Provider>
  );
};
